import { types, Instance, SnapshotOut } from "mobx-state-tree";
import api from "services/api/api";

export const FrameModel = types
  .model("iFrame")
  .props({
    iframeUrl: types.maybeNull(types.string),
  })
  .actions((self) => {
    function setFrame(payload: any) {
      self.iframeUrl = payload.iframeUrl;
    }
    return {
      setFrame,
    };
  })
  .actions((self) => ({
    getFrame: async (id: string, client: string) => {
      try {
        const MetaBase = api.reports;
        const response = await MetaBase.getReport(id, client);
        self.setFrame(response);
      } catch (error) {
        console.log(error);
      }
    },
  }));

type FrameModelType = Instance<typeof FrameModel>;
export type Frames = FrameModelType;
type FrameSnapshotType = SnapshotOut<typeof FrameModel>;
export type FrameSnapshot = FrameSnapshotType;
export const frameDefaultModel = () =>
  types.optional(FrameModel, {
    iframeUrl: "",
  });
